/**
 * 版本检测配置
 */

import { versionTest, versionProd } from '../../../package.json';
import { isBuild } from '@/jmHttp/host';

/**
 * 获取当前应用版本号（区分测试 / 生产环境）
 *
 * isBuild = true  → 生产环境 → 使用 package.json 的 versionProd
 * isBuild = false → 测试环境 → 使用 package.json 的 versionTest
 */
export const getAppVersion = () => {
  return isBuild ? versionProd : versionTest;
};

/** 更新方式枚举 (与后台 updateType 字段对应) */
export const UPDATE_TYPE = {
  STRONG: 0, // 强提示 - 弹框
  MEDIUM: 1, // 中提示 - 顶部 Banner
  SILENT: 2 // 静默更新 - 无 UI 提示，仅消息中心展示
};

export const VERSION_CHECK_CONFIG = {
  production: {
    pollingInterval: 5 * 60 * 1000, // 5 分钟轮询
    maxRetries: 3,
    whitelist: ['/aiChat', '/thirdparty', '/login', '/research/document/share']
  },

  development: {
    pollingInterval: 5 * 60 * 1000,
    maxRetries: 3,
    whitelist: ['/aiChat', '/thirdparty', '/login', '/research/document/share']
  }
};

/**
 * 获取当前环境配置
 */
export const getCurrentConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return VERSION_CHECK_CONFIG[env] || VERSION_CHECK_CONFIG.development;
};

/**
 * 判断路由是否在白名单中（不需要显示升级弹框）
 * @param {string|Object} route - 路由路径字符串或路由对象
 * @returns {boolean} 是否在白名单中
 */
export const isRouteInWhitelist = (route) => {
  const config = getCurrentConfig();
  const whitelist = config.whitelist || [];

  if (!whitelist.length) {
    return false;
  }

  const routePath = typeof route === 'string' ? route : route?.path || route?.fullPath || '';

  if (!routePath) {
    return false;
  }

  return whitelist.some((whitelistPath) => {
    if (routePath === whitelistPath) {
      return true;
    }
    if (routePath.startsWith(whitelistPath + '/') || routePath.startsWith(whitelistPath + '?')) {
      return true;
    }
    return false;
  });
};
